import { z } from 'zod'
import { emailAddress } from './email-address'

export const resendVerificationSchema = z.object({
  email: emailAddress,
})

export type ResendVerificationDto = z.infer<typeof resendVerificationSchema>
